<nb-accordion>
  <nb-accordion-item #item class='notification-filter' id='notification-filter'>
    <nb-accordion-item-header class='notification-filter__header'>
      <div>
        <div class='filter-icon'>
          {{ 'NOTIFICATIONS.FILTER.TITLE' | translate }}({{ filterSelectedCount }})
          <nb-icon icon='more-vertical'
                   nbTooltip="{{ 'NOTIFICATIONS.FILTER.TITLE' | translate }} ({{ filterSelectedCount }})"
                   nbTooltipPlacement='top'
                   pack='eva'></nb-icon>
        </div>
      </div>
      <!-- <button
        nbSuffix
        nbButton
        ghost
        class="filter-actions-vertical"
        [nbPopover]="filerActionsTemplateRef"
        nbPopoverPlacement="left"
      >
        <nb-icon icon="more-vertical-outline" pack="eva"> </nb-icon>
      </button> -->
      <ng-template #filerActionsTemplateRef>
        <div>
          <div class='contextual-actions-popover'>
            <p class='contextual-actions-popover__title'>
              {{ 'ACTIONS.TITLE' | translate }}
            </p>
            <div class='simple-manual'></div>
            <div>&nbsp;</div>
          </div>
        </div>
      </ng-template>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class='search-filter'>
        <nb-form-field>
          <nb-icon icon='search' nbPrefix pack='eva'></nb-icon>
          <input
            (keyup)='filtering = true'
            [(ngModel)]='searchTerm'
            class='input-notification-filter'
            fieldSize='giant'
            fullWidth
            nbInput
            placeholder="{{ 'NOTIFICATIONS.FILTER.TITLE' | translate }}"
            shape='semi-round'
            type='text'
          />
          <button (click)='clearFilterform()' *ngIf='filtering' class='clear-button' ghost nbButton nbSuffix>
            <nb-icon [icon]="filtering ? 'close-outline' : ''" pack='eva'></nb-icon>
          </button>
        </nb-form-field>
        <nb-form-field class='filter-from-date'>
          <nb-icon icon='calendar-outline' nbPrefix pack='eva'></nb-icon>
          <input
            [(ngModel)]='filterFrom'
            [nbDatepicker]='ngmodel'
            class='input-notification-filter'
            fieldSize='giant'
            fullWidth
            nbInput
            onkeydown='return false'
            shape='semi-round'
            type='text'
          />
          <nb-datepicker #ngmodel [max]='max' [min]='min'></nb-datepicker>
        </nb-form-field>
      </div>
      <div>
        <cdk-virtual-scroll-viewport class='viewport' itemSize='18'>
          <nb-list *ngIf='filterSet && filterSet.filtersSelected' class='definition-list'>
            <nb-list-item
              *cdkVirtualFor='
                let definition of filterSet.filtersSelected | filterNotificationName: searchTerm
              '
              class='definition-row'
            >
              <nb-checkbox
                (checkedChange)='toggle($event, definition.id)'
                [checked]='definition.checked'
              ><span
                [innerHTML]='definition.name | highlightSearch: searchTerm'
                [ngClass]='{ selected: definition.checked }'
                class='definition'
              ></span
              ></nb-checkbox>
            </nb-list-item>
          </nb-list>
        </cdk-virtual-scroll-viewport>
      </div>
      <div class='filter-actions'>
        <button (click)='resetFilterSet()' class='button-reset' nbButton shape='semi-round'>
          {{ 'BUTTONS.RESET' | translate }}
        </button>
        <button (click)='cancelFilterSet()' class='button-cancel' nbButton shape='semi-round'>
          {{ 'BUTTONS.CANCEL' | translate }}
          <nb-icon icon='close-outline' pack='eva'></nb-icon>
        </button>
        <button (click)='applyFilterSet()' class='button-apply' nbButton shape='semi-round'>
          {{ 'BUTTONS.APPLY' | translate }}
          <nb-icon icon='checkmark-outline' pack='eva'></nb-icon>
        </button>
        <button (click)='saveFilterSet()' class='button-save' nbButton shape='semi-round'>
          {{ 'BUTTONS.SAVE' | translate }}
          <nb-icon icon='edit-2'></nb-icon>
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
